/* eslint react/jsx-boolean-value: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Container, Col, Row, Button,
} from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';
import Link from '@components/Link';
import constructRelativeLink from '@utils/construct-relative-link';
import './index.scss';

export default function CallToAction(props) {
  const { actions, brandColorOverride } = props;
  const labelUUID = uuidv4();

  return (
    <Container
      aria-labelledby={`CTA-Action-Label-${labelUUID}`}
      className="py-5 banner-container"
      fluid
      style={{ backgroundColor: brandColorOverride }}
    >
      <Row>
        {/* change column width based on 1 or 2 CTAs */}
        <Col className="mx-auto cta-col" md={actions.length === 2 ? 5 : 8} sm={8} xs={10}>
          <h2 id={`CTA-Action-Label-${labelUUID}`}>{actions[0].heading}</h2>
          <p>
            {actions[0].copy}
          </p>
          <Link to={constructRelativeLink(actions[0].buttonUrl)} newTab={actions[0].newTab}>
            <Button size="lg" className="btn-cta" style={{ color: brandColorOverride }}>
              {actions[0].buttonText}
            </Button>
          </Link>
        </Col>
        {actions[1] && (
          <Col className="mx-auto cta-col" md={5} sm={8} xs={10}>
            <h2>{actions[1].heading}</h2>
            <p>
              {actions[1].copy}
            </p>
            <Link to={constructRelativeLink(actions[1].buttonUrl)} newTab={actions[1].newTab}>
              <Button size="lg" className="btn-cta" style={{ color: brandColorOverride }}>
                {actions[1].buttonText}
              </Button>
            </Link>
          </Col>
        )}
      </Row>
    </Container>
  );
}

CallToAction.defaultProps = {
  brandColorOverride: null,
};

CallToAction.propTypes = {
  // TODO: Fix this eslint warning and remove whitelisting
  // eslint-disable-next-line react/forbid-prop-types
  actions: PropTypes.arrayOf(PropTypes.object).isRequired,
  brandColorOverride: PropTypes.string,
};
